// MiWay 4.0 — vollständiger Survey-Content
// Texte 1:1 aus den Specs: mi_motivator (35 Motivatoren + 35 Demotivatoren),
// mi_sentence (490 Definitionen mit Wertedimensions-Mapping über die "color"-Spalte).
// Reihenfolge wie im Spec-Dump (textid).

export const PERSON_DEMOGRAPHICS = {
  bereich: [
    'Bildung und Soziales',
    'Einkauf, Materialwirtschaft und Logistik',
    'Finanzen',
    'Forschung und Entwicklung',
    'Geschäftsleitung',
    'IT',
    'Marketing und Kommunikation',
    'Personal',
    'Pflege, Therapie und Assistenz',
    'Produktion',
    'Projektmanagement',
    'Recht',
    'Vertrieb und Verkauf',
    'Verwaltung und Sekretariat',
    'Ärzte',
    'Öffentlicher Dienst',
    'Sonstiges',
  ],
  branche: [
    'Anlagen- und Maschinenbau', 'Automobilindustrie', 'Baugewerbe und Handwerk',
    'Bildung und Forschung', 'Druck, Papier und Verpackung', 'Einzelhandel',
    'Elektrotechnik', 'Energie- und/oder Wasserversorger', 'Finanzdienstleistungen',
    'Freiberufliche, wissenschaftliche und technische Dienstleistungen', 'Gastgewerbe',
    'Gesundheits- und Sozialwesen', 'Großhandel und Spedition',
    'Immobilien, Grundstücks- und Wohnungswesen', 'Informations- und Kommunikationstechnik',
    'Konsumgüterindustrie', 'Land- und Forstwirtschaft, Fischerei', 'Logistik und Verkehr',
    'Luft- und Raumfahrt', 'Medien, Kunst, Unterhaltung, Verlage',
    'Pharma, Chemie, Biotechnik, Medizintechnik', 'Schwerindustrie',
    'Sonstige Dienstleistungen', 'Unternehmensberatung', 'Verarbeitendes Gewerbe',
    'Versicherungen', 'Wirtschaftliche Dienstleistungen', 'Öffentlicher Sektor',
    'Sonstiges',
  ],
  fuehrung: ['disziplinarisch', 'fachlich', 'keine'],
  // Logisch aufsteigende Reihenfolge laut Spec
  bildung: [
    'Mittlere Reife', 'Fachhochschulreife', 'Allgemeine Hochschulreife',
    'Techniker', 'Meister', 'Bachelor', 'Master', 'Diplom/Magister',
    'Promotion', 'Habilitation', 'Sonstiges',
  ],
}

// Helper: build a definition entry with text + dimension key
const d = (text, dimKey) => ({ text, dim: dimKey })

export const MOTIVATORS = [
  { label: 'Herausforderung', defs: [
    d('man sich ihr in einem gewohnten Umfeld stellen kann.', 'violet'),
    d('man dadurch aktiv die eigene Stärke zeigen und Einfluss gewinnen kann.', 'red'),
    d('sie darin besteht, neue Strukturen und Abläufe zu etablieren.', 'blue'),
    d('man sich dadurch im Wettbewerb beweisen kann.', 'orange'),
    d('diese gemeinsam im Team bewältigt werden kann.', 'green'),
    d('diese darin besteht, sich neue komplexe Themenfelder zu erschließen.', 'yellow'),
    d('man globale Themenfelder erkennen und mit Weitblick angehen kann.', 'turquoise'),
  ] },
  { label: 'Ausgewogenheit von Berufs- und Privatleben', defs: [
    d('diese durch Traditionen sicher verankert ist.', 'violet'),
    d('man dadurch selbstbestimmt die individuellen Prioritäten setzen kann.', 'red'),
    d('diese durch klare Vorgaben und Regeln definiert ist.', 'blue'),
    d('dadurch das Erreichen von Zielen und Erfolgen gestärkt wird.', 'orange'),
    d('man diese durch die Kontakte im Team erreicht.', 'green'),
    d('man dadurch die vielfältigen Möglichkeiten beider Bereiche so nutzt, dass sie sich gegenseitig bereichern.', 'yellow'),
    d('beide Lebensbereiche nicht getrennt, sondern als Teil eines großen Ganzen erlebt werden können.', 'turquoise'),
  ] },
  { label: 'Identifikationsmöglichkeiten', defs: [
    d('sich diese auf gelebte Traditionen beziehen.', 'violet'),
    d('diese den eigenen Weg frei und unabhängig in den Mittelpunkt stellen.', 'red'),
    d('sie auf verlässliche Strukturen zurückzuführen sind.', 'blue'),
    d('sie durch ambitionierte Ziele bestimmt sind.', 'orange'),
    d('sie die Einbindung in ein Team von Gleichgesinnten mit sich bringen.', 'green'),
    d('sie in einer vielschichtigen Tätigkeit durch das Einbringen von Wissen und Kompetenz entstehen.', 'yellow'),
    d('sie ein global und ökologisch orientiertes Arbeitsumfeld einbeziehen.', 'turquoise'),
  ] },
  { label: 'Ehrlichkeit', defs: [
    d('einem im Zuge dessen die Aufrichtigkeit der Gruppe Schutz bietet.', 'violet'),
    d('man offen zu seinem Tatendrang und seiner Durchsetzungsstärke stehen kann.', 'red'),
    d('Menschen sich dadurch verlässlich an Regeln und Autoritäten halten.', 'blue'),
    d('aufgrund dessen Wettbewerbssituationen bewusst begegnet wird.', 'orange'),
    d('man sich dadurch auf die Offenheit und Aufrichtigkeit des Teams verlassen kann.', 'green'),
    d('man dadurch offen zu seinen hohen Ansprüchen an Qualität und Kompetenz stehen kann.', 'yellow'),
    d('infolgedessen Visionen über Nachhaltigkeit glaubwürdig und offen kommuniziert werden.', 'turquoise'),
  ] },
  { label: 'Energie', defs: [
    d('sie aus dem Gefühl der Zugehörigkeit geschöpft wird.', 'violet'),
    d('man diese aus seinem eigenen kraftvollen und unabhängigen Handeln zieht.', 'red'),
    d('man sie aus der pflichtbewussten und verlässlichen Erledigung seiner Aufgaben schöpft.', 'blue'),
    d('sie durch den Wettbewerb mit anderen aktiviert wird.', 'orange'),
    d('sie durch ein anerkennendes und harmonisches Miteinander entsteht.', 'green'),
    d('man sie aus vielfältigen Optionen und dem Durchdringen komplexer Zusammenhänge schöpfen kann.', 'yellow'),
    d('man sie aus einem ganzheitlichen Wirken für eine gerechtere Welt zieht.', 'turquoise'),
  ] },
  { label: 'Ausgeglichenheit', defs: [
    d('man sie durch das Vorhandensein bekannter Wege findet.', 'violet'),
    d('man sie durch kraftvolles und unabhängiges Handeln selbst erzeugt.', 'red'),
    d('sie durch stabilisierende und geordnete Strukturen erlebt werden kann.', 'blue'),
    d('diese aus dem eigenen Einsatz und daraus resultierendem Erfolg besteht.', 'orange'),
    d('man sie im gemeinsamen Arbeiten mit Gleichgesinnten findet.', 'green'),
    d('man sie durch das Vertiefen in vielschichtige Gedankengänge erfährt.', 'yellow'),
    d('man sie dadurch erfährt, dass wirtschaftliches und ethisches Handeln im Einklang ist.', 'turquoise'),
  ] },
  { label: 'Erfolg', defs: [
    d('man diesen in einem stabilen Umfeld und in Einklang mit den Traditionen erzielen kann.', 'violet'),
    d('dies bedeutet, die eigene Position und den eigenen Einfluss zu stärken.', 'red'),
    d('dadurch Aufgaben strukturiert und zuverlässig abgeschlossen werden können.', 'blue'),
    d('man im Wettbewerb gegen die Konkurrenz bestehen kann.', 'orange'),
    d('dieser im Team erzielt wird und allen Mitgliedern der Organisation zugutekommt.', 'green'),
    d('er darin besteht, komplexe Zusammenhänge zu durchdringen und optimale Lösungen zu finden.', 'yellow'),
    d('man durch ihn globale Entwicklungen wirksam beeinflussen kann.', 'turquoise'),
  ] },
  { label: 'Flexibilität', defs: [
    d('diese weiterhin Sicherheit im Einklang mit Traditionen bietet.', 'violet'),
    d('man durch diese selbstbestimmt und mit Tatkraft seine eigenen Vorstellungen realisieren kann.', 'red'),
    d('diese die Erfüllung wechselnder Anforderungen und Aufgaben innerhalb eines klaren Rahmens unterstützt.', 'blue'),
    d('man sich dadurch im Wettbewerb auf wechselnde Anforderungen einstellen kann.', 'orange'),
    d('im Team aufgrund dessen offen mit emotionalen Bedürfnissen umgegangen werden kann.', 'green'),
    d('dadurch vielfältige neue Lösungen entwickelt werden können.', 'yellow'),
    d('diese es ermöglicht, den globalen Veränderungen mit nachhaltigem Umdenken zu begegnen.', 'turquoise'),
  ] },
  { label: 'Freiraum', defs: [
    d('dieser innerhalb bewährter Traditionen ermöglicht wird.', 'violet'),
    d('man dadurch eigene Interessen verfolgen und sich behaupten kann.', 'red'),
    d('sich daraus die Möglichkeit ergibt, ordentlich und strukturiert zu arbeiten.', 'blue'),
    d('hierdurch ehrgeizige individuelle Ziele erreicht werden können.', 'orange'),
    d('man diesen innerhalb des Teams einfordern kann, ohne die Harmonie zu gefährden.', 'green'),
    d('dieser für die kreative Beschäftigung mit komplexen Fragestellungen eingesetzt werden kann.', 'yellow'),
    d('man diesen für die Entfaltung globalen Denkens und ganzheitlichen Erlebens hat.', 'turquoise'),
  ] },
  { label: 'Persönliche Bindungen', defs: [
    d('diese verlässlich sind und Rückhalt geben.', 'violet'),
    d('man sie nutzen kann, um die eigene Position zu stärken.', 'red'),
    d('diese auf Loyalität und Zuverlässigkeit begründet sind.', 'blue'),
    d('man diese nutzen kann, um den eigenen Erfolg zu steigern.', 'orange'),
    d('dadurch Zusammenhalt und Einfühlungsvermögen in der Organisation einen hohen Stellenwert gewinnen.', 'green'),
    d('sie zu kreativen und hochkompetenten Netzwerken führen.', 'yellow'),
    d('diese als Informationsnetzwerke für globale Problemlösungen genutzt werden können.', 'turquoise'),
  ] },
  { label: 'Gerechtigkeit', defs: [
    d('diese mit sich bringt, dass alle ihren sicheren und angestammten Platz haben.', 'violet'),
    d('dadurch abgesichert ist, dass die stärkere Persönlichkeit auch den Einfluss und die Führung innehat.', 'red'),
    d('diese sicherstellt, dass für alle die gleichen Regeln und Standards gelten.', 'blue'),
    d('dadurch gewährleistet ist, dass man für seine Erfolge entlohnt wird.', 'orange'),
    d('dies bedeutet, dass alle ihre persönlichen Bedürfnisse vorbringen können.', 'green'),
    d('diese bedeutet, dass jede Person die Chance zur individuellen Wissenserweiterung hat.', 'yellow'),
    d('man dadurch zum Einsatz für einen sozialen und ökologischen im Umgang mit den Menschen beiträgt.', 'turquoise'),
  ] },
  { label: 'Soziale Verantwortung', defs: [
    d('diese darin besteht, stets im Sinne einer sicheren Gemeinschaft zu handeln.', 'violet'),
    d('man dadurch den eigenen Einfluss und den eigenen Freiraum erweitern kann.', 'red'),
    d('diese bedeutet, dass man durch Pflichtbewusstsein und Loyalität zur Stabilität der Organisation beitragen kann.', 'blue'),
    d('damit zugleich die Wettbewerbsfähigkeit der Organisation verbessert werden kann.', 'orange'),
    d('man diese im Team übernimmt und dadurch die Beziehungsebene in den Vordergrund rückt.', 'green'),
    d('man diese durch das Einbringen seiner Fertigkeiten und Erkenntnisse übernehmen kann.', 'yellow'),
    d('man ihr durch nachhaltiges, globales Engagement gerecht werden kann.', 'turquoise'),
  ] },
  { label: 'Gestaltungsmöglichkeit', defs: [
    d('diese zu Verstetigungen und Traditionen beiträgt.', 'violet'),
    d('sich damit Räume öffnen, eigene Ideen sehr unabhängig umzusetzen.', 'red'),
    d('man durch sie eindeutige Strukturen und Abläufe schaffen kann.', 'blue'),
    d('man damit den eigenen Erfolg und die eigene Zielerreichung maximieren kann.', 'orange'),
    d('man damit das Wir-Gefühl im Team fördern kann.', 'green'),
    d('man diese nutzen kann, um sein Wissen und seine Fertigkeiten effektiv einzusetzen.', 'yellow'),
    d('man dadurch die Organisation unter ethischen Gesichtspunkten weiterentwickeln kann.', 'turquoise'),
  ] },
  { label: 'Gute Arbeitsatmosphäre', defs: [
    d('dies heißt, in einer Gemeinschaft tätig zu sein, in der man sich sicher und zugehörig fühlt.', 'violet'),
    d('dies heißt, Anerkennung und Respekt für seinen kraftvollen Einsatz zu bekommen.', 'red'),
    d('sie durch Verlässlichkeit, Verbindlichkeit und Pflichtbewusstsein geprägt ist.', 'blue'),
    d('sie durch Erfolgsorientierung und Lust am Wettbewerb definiert wird.', 'orange'),
    d('diese offen, vertrauensvoll und konsensorientiert ist und der Mensch im Vordergrund steht.', 'green'),
    d('diese sich durch die Möglichkeit der intellektuellen Entfaltung auszeichnet.', 'yellow'),
    d('diese durch globales Denken und Nachhaltigkeit geprägt ist.', 'turquoise'),
  ] },
  { label: 'Innovation', defs: [
    d('sie überschaubar ist und im Einklang mit vorhandenen Traditionen erfolgt.', 'violet'),
    d('man durch sie mutig neue Bereiche erobern kann.', 'red'),
    d('sie zu neuen und besser strukturierten Arbeitsabläufen führt.', 'blue'),
    d('sie zum Erfolg am Markt führt.', 'orange'),
    d('man aufgrund dessen gemeinsam und im Konsens Ideen entwickeln kann.', 'green'),
    d('sie das Ergebnis einer kreativen Auseinandersetzung mit vernetzten, komplexen Zusammenhängen ist.', 'yellow'),
    d('diese global zur Verbesserung der Lebenssituation von Menschen beiträgt.', 'turquoise'),
  ] },
  { label: 'Inspiration', defs: [
    d('sie in einem Umfeld entsteht, in dem ich mich sicher fühle.', 'violet'),
    d('sie aus eigener Kraft und eigenen Einflussmöglichkeiten entsteht.', 'red'),
    d('diese durch klare Vorgaben Orientierung und Sinn stiftet.', 'blue'),
    d('sie es ermöglicht, Ziele zu erreichen und das Optimum zu leisten.', 'orange'),
    d('diese auf persönlichen Begegnungen und Teamgeist beruht.', 'green'),
    d('sie durch neue Erkenntnisse entsteht.', 'yellow'),
    d('diese durch ganzheitliche Erfahrungen und eine visionäre Weltsicht entsteht.', 'turquoise'),
  ] },
  { label: 'Integrität', defs: [
    d('dadurch die traditionellen Werte der Gemeinschaft aufrechterhalten werden.', 'violet'),
    d('diese bedeutet, dass man sich selbst und seinen eigenen Zielen treu bleiben kann.', 'red'),
    d('dadurch die Arbeit gewissenhaft und diszipliniert im Sinne der Organisation erledigt wird.', 'blue'),
    d('man sich dadurch auch im Wettbewerb nach den eigenen leistungsorientierten Werten verhalten kann.', 'orange'),
    d('dadurch soziales Bewusstsein, gesellschaftliche Verantwortung und Vertrauen gelebt werden können.', 'green'),
    d('diese bedeutet, dass man zu seinen Ansprüchen an Flexibilität und geistige Freiräume stehen kann.', 'yellow'),
    d('diese bedeutet, im Einklang mit den eigenen idealistischen und ethischen Werten leben zu können.', 'turquoise'),
  ] },
  { label: 'Internationalität', defs: [
    d('dadurch die Traditionen der eigenen Gemeinschaft stärker hervortreten können.', 'violet'),
    d('man aufgrund dessen in einem internationalen Umfeld eigenverantwortlich handeln und Dinge bewegen kann.', 'red'),
    d('man sich auch bei internationalen Prozessen auf Regeln und Prinzipien verlassen kann.', 'blue'),
    d('sie den Wettbewerb fördert.', 'orange'),
    d('man damit auch auf internationaler Ebene Beziehungen zu Gleichgesinnten aufbauen kann.', 'green'),
    d('dadurch ein internationaler (Wissens-)Austausch neue Ideen und Möglichkeiten generiert.', 'yellow'),
    d('man in internationalen Projekten eine bessere Zukunft mitgestalten kann.', 'turquoise'),
  ] },
  { label: 'Klarheit', defs: [
    d('diese Gewissheit über gemeinschaftliche Werte und Traditionen schafft.', 'violet'),
    d('sie den eigenen Weg erkennbar und durchsetzbar macht.', 'red'),
    d('diese durch verbindliche Regeln und Richtungsvorgaben erzeugt wird.', 'blue'),
    d('diese Planbarkeit und Kontrolle von Maßnahmen zur Zielerreichung ermöglicht.', 'orange'),
    d('dadurch Partizipation und Konsens im Team gestärkt werden.', 'green'),
    d('dadurch das Verständnis komplexer Zusammenhänge gefördert wird.', 'yellow'),
    d('man dadurch Gesamtzusammenhänge erkennen und nachhaltige Handlungsoptionen ableiten kann.', 'turquoise'),
  ] },
  { label: 'Leidenschaftliches Engagement', defs: [
    d('man sich für die Sicherheit der Gruppe und die Aufrechterhaltung gemeinsamer Werte einsetzen kann.', 'violet'),
    d('man dadurch tatkräftig Dinge bewegen kann.', 'red'),
    d('man sich im Zuge dessen für vorschriftsmäßiges Handeln und Ordnung einsetzen kann.', 'blue'),
    d('es der Zielerreichung und dem eigenen Erfolg dient.', 'orange'),
    d('sich dieses auf das Team und die Gesellschaft bezieht.', 'green'),
    d('dieses komplexe Analysen und die Suche nach vielfältigen Optionen mit sich bringt.', 'yellow'),
    d('dadurch globale, nachhaltige Themen in den Mittelpunkt gerückt werden.', 'turquoise'),
  ] },
  { label: 'Leistung', defs: [
    d('man diese innerhalb der Gemeinschaft zur Gewährleistung von Sicherheit erbringen kann.', 'violet'),
    d('diese auf Basis von Mut und Durchsetzungsvermögen erbracht wird.', 'red'),
    d('man diese zuverlässig und strukturiert erbringen kann.', 'blue'),
    d('man alles geben kann, um erfolgreich zu sein.', 'orange'),
    d('man diese im Team und durch gemeinsames Engagement erbringen kann.', 'green'),
    d('darunter verstanden wird, große intellektuelle Herausforderungen zu bewältigen.', 'yellow'),
    d('sie sich durch einen nachhaltigen Beitrag zum Gemeinwohl auf globaler Ebene auszeichnet.', 'turquoise'),
  ] },
  { label: 'Loyalität', defs: [
    d('diese gegenüber der Gemeinschaft und ihren traditionellen Werten empfunden wird.', 'violet'),
    d('man zu sich selbst und seinen Stärken stehen kann.', 'red'),
    d('diese in hohem Maße gegenüber den vorhandenen Institutionen gelebt werden kann.', 'blue'),
    d('man diese gegenüber dem eigenen Erfolg und vorgegebenen Zielen zeigen kann.', 'orange'),
    d('sich diese in vertrauensvollen Beziehungen zu den Menschen, mit denen man arbeitet, zeigt.', 'green'),
    d('diese mit sich bringt, dass alle ihr Wissen und ihre Fertigkeiten zur Weiterentwicklung einsetzen.', 'yellow'),
    d('sie bedeutet, sich mit idealistischem Anspruch für das Wohl der Menschheit einzusetzen.', 'turquoise'),
  ] },
  { label: 'Einfluss', defs: [
    d('dieser traditionell geprägt aufgrund von Erfahrung und Seniorität vergeben wird.', 'violet'),
    d('man diesen in einem hohen Maß unabhängig von anderen ausüben kann.', 'red'),
    d('er zur Optimierung von Strukturen und Ordnungen genutzt werden kann.', 'blue'),
    d('dieser durch das Erzielen von Erfolgen im Wettbewerb erlangt werden kann.', 'orange'),
    d('dadurch Entscheidungen im Team maßgebliche Wirkung haben können.', 'green'),
    d('man diesen durch sein Wissen und seine Kompetenz erlangen kann.', 'yellow'),
    d('dieser auf eine globale, nachhaltige Entwicklung einzahlt.', 'turquoise'),
  ] },
  { label: 'Persönliche Entwicklung', defs: [
    d('diese im Schutze der Gemeinschaft stattfinden kann.', 'violet'),
    d('man dadurch persönliche Stärke in großer Unabhängigkeit entwickeln kann.', 'red'),
    d('diese innerhalb strukturierter Laufbahnen stattfinden kann.', 'blue'),
    d('diese mit Erfolgssteigerung und höherer Produktivität einhergeht.', 'orange'),
    d('diese im Kontext wertschätzender Beziehungen erfolgen kann.', 'green'),
    d('man im Zuge dessen durch Kompetenz- und Wissenserweiterung persönlich reifen kann.', 'yellow'),
    d('diese durch ganzheitliche Erfahrungen erfolgt und eine ethische Grundhaltung stärkt.', 'turquoise'),
  ] },
  { label: 'Professionalität', defs: [
    d('sich diese in traditionsbewusstem und gemeinschaftsorientiertem Handeln zeigt.', 'violet'),
    d('sie in der kraftvollen Umsetzung eigener Ideen besteht.', 'red'),
    d('diese durch verbindliche Standards und Verantwortungsbewusstsein definiert ist.', 'blue'),
    d('diese durch Zielstrebigkeit und Erfolgsorientierung geprägt ist.', 'orange'),
    d('diese bedeutet, konsensorientiert und vertrauensvoll miteinander zu arbeiten.', 'green'),
    d('dadurch hohe Qualitäts- und Kompetenzstandards gelebt werden können.', 'yellow'),
    d('aufgrund dessen durch ganzheitliches Denken die Probleme dieser Welt angegangen werden können.', 'turquoise'),
  ] },
  { label: 'Verhalten der Führungskraft', defs: [
    d('dieses traditionsbewusst auf die gesamte Belegschaft ausgerichtet ist.', 'violet'),
    d('dieses Unabhängigkeit und Stärke beweist.', 'red'),
    d('diese klare Richtungsvorgaben macht werden und dadurch ordnungsgemäßes Arbeiten anerkannt wird.', 'blue'),
    d('dadurch herausfordernde Ziele vereinbart und Leistung angemessen belohnt werden.', 'orange'),
    d('dieses die Bedürfnisse der Mitarbeitenden berücksichtigt und für eine vertrauensvolle Atmosphäre sorgt.', 'green'),
    d('dieses Lernbereitschaft und Wissenserweiterung durch Zugang zu allen Ressourcen fördert.', 'yellow'),
    d('es von ethischen Grundsätzen und visionärem Denken geprägt ist.', 'turquoise'),
  ] },
  { label: 'Sicherheit', defs: [
    d('diese in hohem Maße durch allgemein akzeptierte Vorgehensweisen gewährleistet wird.', 'violet'),
    d('man sie aus der eigenen Position und den eigenen Kontrollmöglichkeiten schöpfen kann.', 'red'),
    d('sie durch Regelungen und Vorgaben gewährleistet wird.', 'blue'),
    d('durch sie die Gewissheit entsteht, dass hohes Engagement auch zum Erfolg führt.', 'orange'),
    d('man dadurch gewiss sein kann, mit seinen individuellen Bedürfnissen als Teammitglied anerkannt zu sein.', 'green'),
    d('aufgrund dessen komplexes Denken die Gewissheit vermittelt, sich in einem instabilen Umfeld orientieren zu können.', 'yellow'),
    d('man diese durch globale Weitsicht und visionäres Denken für die Gesamtheit gewährleistet wird.', 'turquoise'),
  ] },
  { label: 'Spaß haben', defs: [
    d('dies in einer traditionsorientierten Gemeinschaft erfolgt.', 'violet'),
    d('dies bedeutet, Mut und Kraft in der eigenen Tätigkeit ausleben zu können.', 'red'),
    d('man dies in einem klar geordneten und strukturierten Kontext erfolgt.', 'blue'),
    d('dieser bedeutet, sich mit anderen im Wettbewerb zu messen.', 'orange'),
    d('man diesen in der Teamarbeit und mit den Teammitgliedern zusammen erleben kann.', 'green'),
    d('dieser durch komplexe Analysen und intellektuelle Höchstleistungen entsteht.', 'yellow'),
    d('man damit andere für globale und nachhaltig wirksame Aktionen gewinnen kann.', 'turquoise'),
  ] },
  { label: 'Respekt', defs: [
    d('aufgrund dessen mit einem hohen Sicherheitsbedürfnis rücksichtsvoll umgegangen wird.', 'violet'),
    d('man diesen für seinen Mut, seine Stärke und seinen Tatendrang erfährt.', 'red'),
    d('man diesen für sein Pflichtbewusstsein, seine Disziplin und seine Loyalität erfährt.', 'blue'),
    d('man diesen für seine Wettbewerbs- und Erfolgsorientierung erhält.', 'orange'),
    d('man ihn für den sensiblen und angemessenen Umgang mit den individuellen Bedürfnissen von Menschen erhält.', 'green'),
    d('man diesen dafür erhält, komplexe Probleme kreativ und kompetent zu lösen.', 'yellow'),
    d('man diesen für sein nachhaltiges und ethisches Handeln erfährt.', 'turquoise'),
  ] },
  { label: 'Kreativität', defs: [
    d('diese darauf ausgerichtet ist, die Traditionen der Gemeinschaft zu stärken.', 'violet'),
    d('damit man eigene Vorstellungen in Taten umsetzen kann.', 'red'),
    d('diese innerhalb klarer Strukturen und Vorgaben möglich ist.', 'blue'),
    d('man dadurch besser zum Ziel kommt.', 'orange'),
    d('man diese in der Zusammenarbeit mit dem Team zeigen kann.', 'green'),
    d('man dadurch seinen Einfallsreichtum nutzen kann, um komplexe Probleme zu lösen.', 'yellow'),
    d('man diese auf globaler Ebene für nachhaltige Entwicklungsprozesse einsetzen kann.', 'turquoise'),
  ] },
  { label: 'Teamarbeit', defs: [
    d('dadurch Traditionen und Beständigkeit gestärkt werden.', 'violet'),
    d('innerhalb der Zusammenarbeit eigenverantwortliches Handeln und Einflussnahme möglich sind.', 'red'),
    d('diese innerhalb strukturierter und geordneter Bahnen stattfindet.', 'blue'),
    d('man dadurch eine bessere Wettbewerbssituation erreichen kann.', 'orange'),
    d('diese von persönlichen Beziehungen und Partizipation geprägt ist.', 'green'),
    d('dadurch die Analyse komplexer Themenfelder ermöglicht wird.', 'yellow'),
    d('dadurch nachhaltige Lösungen zum Wohle des Ganzen erreicht werden können.', 'turquoise'),
  ] },
  { label: 'Unabhängigkeit', defs: [
    d('diese auch in einer sicheren Gemeinschaft möglich ist.', 'violet'),
    d('man durch Mut und Tatendrang ein hohes Maß an Autonomie erreichen kann.', 'red'),
    d('dadurch Abläufe verlässlich und unabhängig von Einzelpersonen funktionieren.', 'blue'),
    d('man damit in Wettbewerbssituationen eigenständig Erfolge erzielen kann.', 'orange'),
    d('man sich dadurch auch im Team eigenständig verwirklichen und das Team voranbringen kann.', 'green'),
    d('man damit die gedankliche Freiheit hat, komplexe Zusammenhänge unvoreingenommen zu analysieren.', 'yellow'),
    d('diese einem erlaubt, eine ganzheitliche Sicht der Dinge einnehmen zu können.', 'turquoise'),
  ] },
  { label: 'Unternehmerisches Denken', defs: [
    d('es darauf ausgerichtet ist, sicher zu wirtschaften und Bewährtes zu erhalten.', 'violet'),
    d('man damit Dinge nach eigenen Vorstellungen bewegen kann.', 'red'),
    d('dieses auf den Aufbau stabiler Strukturen ausgerichtet ist, die effiziente Abläufe ermöglichen.', 'blue'),
    d('darunter verstanden wird, Wettbewerbsvorteile zu nutzen und Gewinn zu erzielen.', 'orange'),
    d('dieses auf Partizipation ausgerichtet ist und eine hohe Teamorientierung widerspiegelt.', 'green'),
    d('es sich in einem Verständnis von Komplexität und einer innovativen Ausrichtung zeigt.', 'yellow'),
    d('dieses sowohl auf ökologische als auch auf menschliche Belange ausgerichtet ist.', 'turquoise'),
  ] },
  { label: 'Vertrauen', defs: [
    d('man dadurch der Führung und der Gemeinschaft Glauben schenken kann.', 'violet'),
    d('man sich aufgrund dessen der eigenen Stärke und Leistungsfähigkeit sicher sein kann.', 'red'),
    d('man sich dadurch auf die Einhaltung der bestehenden Strukturen und Absprachen verlassen kann.', 'blue'),
    d('man dadurch darauf zählen kann, dass sich erfolgsorientiertes Engagement auszahlt.', 'orange'),
    d('infolgedessen persönliche Beziehungen im Team einen hohen Stellenwert haben.', 'green'),
    d('man sich im Zuge dessen auf das eigene Wissen und Können verlassen kann.', 'yellow'),
    d('man dadurch Zuversicht für gemeinsames nachhaltiges Denken und Handeln schafft.', 'turquoise'),
  ] },
  { label: 'Erkenntnis', defs: [
    d('man diese aus Traditionen gewinnen kann.', 'violet'),
    d('man diese im Alleingang und durch eigene Kraft erlangt.', 'red'),
    d('diese aus der Schaffung klarer Strukturen entsteht.', 'blue'),
    d('man diese als Wettbewerbsvorteil nutzen kann.', 'orange'),
    d('diese aus dem Prozess der Konsensfindung mit den Teammitgliedern entsteht.', 'green'),
    d('man diese aus der Durchdringung komplexer Zusammenhänge gewinnt.', 'yellow'),
    d('man diese über die Betrachtung globaler Zusammenhänge erlangen kann.', 'turquoise'),
  ] },
]

export const DEMOTIVATORS = [
  { label: 'Arroganz', defs: [
    d('diese sich darin ausdrückt, dass Traditionen über alles andere gestellt werden.', 'violet'),
    d('Menschen ihre eigenen Interessen machtfokussiert über die Interessen anderer stellen.', 'red'),
    d('Menschen sich selbstgefällig darauf berufen, nach Recht und Ordnung zu handeln.', 'blue'),
    d('sich diese darin zeigt, dass Menschen immer besser sein wollen als die anderen.', 'orange'),
    d('sich diese darin äußert, dass das Team über Einzelne gestellt wird.', 'green'),
    d('Personen sich anmaßen, ihr eigenes Wissen über das Wissen anderer zu stellen.', 'yellow'),
    d('ganzheitlich denkende Menschen andere Sichtweisen abwerten.', 'turquoise'),
  ] },
  { label: 'Distanzlosigkeit', defs: [
    d('sich diese darin ausdrückt, dass Menschen ihr hohes Sicherheitsbedürfnis anderen aufzwingen wollen.', 'violet'),
    d('Menschen ihren Einfluss ungewollt geltend machen.', 'red'),
    d('Menschen anderen ihre Struktur und Ordnung aufdrängen wollen.', 'blue'),
    d('diese bedeutet, dass andere einen in Wettbewerbssituationen drängen wollen.', 'orange'),
    d('diese bedeutet, dass einem emotionale Bekenntnisse aufgedrängt werden.', 'green'),
    d('Menschen in intellektuell anspruchsvollen Diskussionen anderen ihr Wissen aufzwingen wollen.', 'yellow'),
    d('jemand ungefragt versucht, andere von den eigenen ethischen Überzeugungen zu überzeugen.', 'turquoise'),
  ] },
  { label: 'Bürokratie', defs: [
    d('enge Vorschriften allein aus einem hohem Sicherheitsbedürfnis heraus aufgestellt werden.', 'violet'),
    d('diese als Stütze von Macht und Kontrolle dient.', 'red'),
    d('der Zweck regelbasierter Abläufe nicht mehr erkennbar ist.', 'blue'),
    d('Leistung und Zielerreichung kontrolliert werden.', 'orange'),
    d('aus formalen Gründen an teamorientierten Gruppenregeln festgehalten wird.', 'green'),
    d('umfangreiche Regelwerke die Komplexität einer Organisation erhöhen, statt sie zu reduzieren.', 'yellow'),
    d('sie einseitig Weltverbesserungsideale durchsetzt.', 'turquoise'),
  ] },
  { label: 'Chaos', defs: [
    d('Menschen unflexibel an Bewährtem festhalten.', 'violet'),
    d('dieses durch unangepasstes oder impulsives Verhalten entsteht.', 'red'),
    d('Menschen wichtige Regeln nicht mehr einhalten.', 'blue'),
    d('es durch zu viele ehrgeizige Ziele verursacht wird.', 'orange'),
    d('durch die Berücksichtigung aller Bedürfnisse der Zusammenhalt verloren geht.', 'green'),
    d('es durch die Berücksichtigung zu vieler Möglichkeiten und Perspektiven entsteht.', 'yellow'),
    d('es durch die unprofessionelle Einführung von Nachhaltigkeitskonzepten entsteht.', 'turquoise'),
  ] },
  { label: 'Desinteresse', defs: [
    d('Personen nicht offen für Neues sind und am Gewohnten festhalten wollen.', 'violet'),
    d('es sich darin äußert, dass jemand ausschließlich das eigene Fortkommen im Blick hat.', 'red'),
    d('der Fokus auf Regeln und Vorschriften alles andere in den Hintergrund drängt.', 'blue'),
    d('es sich darin äußert, dass nur Ergebnisse und der eigene Erfolg zählen.', 'orange'),
    d('außer dem Team nichts anderes zählt.', 'green'),
    d('Personen sich für nichts interessieren, was nicht ihrem hohen Anspruch an Wissen und Kompetenz entspricht.', 'yellow'),
    d('ein globaler Fokus dazu führt, dass lokale Probleme vernachlässigt werden.', 'turquoise'),
  ] },
  { label: 'Dinge kompliziert machen', defs: [
    d('Traditionen und ein hohes Sicherheitsbedürfnis die Arbeitssituation unnötig verkomplizieren.', 'violet'),
    d('Menschen durch kraftvolles Auftreten Probleme verursachen.', 'red'),
    d('Regeln und Vorschriften die Arbeitssituation verkomplizieren.', 'blue'),
    d('eine hohe Wettbewerbsorientierung die Aufgabenerfüllung erschwert.', 'orange'),
    d('die obligatorische Beteiligung aller die Prozesse unnötig verlangsamt.', 'green'),
    d('dies durch hochgeistige und komplexe Diskussionen geschieht.', 'yellow'),
    d('der permanente Anspruch nach ganzheitlichem Denken und Handeln viele überfordert.', 'turquoise'),
  ] },
  { label: 'Egoistisches Verhalten', defs: [
    d('Menschen alles ausschließlich für ihre eigene Sicherheit tun.', 'violet'),
    d('Personen für sich selbst und die Stärkung der eigenen Position kämpfen.', 'red'),
    d('Regulierungen und Vorschriften nur aus eigennützigen Interessen geschaffen werden.', 'blue'),
    d('Personen nur auf ihren eigenen Erfolg bedacht sind.', 'orange'),
    d('das persönliche Wohlergehen in den Vordergrund des Teams gestellt wird.', 'green'),
    d('Menschen durch ihr Festhalten an hohen Kompetenzansprüchen andere übergehen.', 'yellow'),
    d('Menschen die Auswirkungen ethischer Konzepte nur aus ihrer eigenen Situation heraus bewerten.', 'turquoise'),
  ] },
  { label: 'Einzelkämpfertum', defs: [
    d('Personen für überholte Traditionen kämpfen.', 'violet'),
    d('sich jemand unabhängig von anderen Macht und Einfluss sichern will.', 'red'),
    d('jemand Regeln und Strukturen unabgestimmt durchsetzen will.', 'blue'),
    d('Menschen im Wettbewerb ausschließlich für sich selbst kämpfen.', 'orange'),
    d('sich dieses auf Teamebene darin zeigt, dass sich Teams zu sehr mit sich selbst beschäftigen.', 'green'),
    d('jemand komplexe Aufgaben immer alleine angeht.', 'yellow'),
    d('Menschen glauben, sie könnten die Welt alleine verbessern.', 'turquoise'),
  ] },
  { label: 'Entscheidungsschwäche', defs: [
    d('diese aus einer zu hohen Traditions- und Sicherheitsorientierung entsteht.', 'violet'),
    d('diese auf den impulsiven Tatendrang Einzelner zurückgeführt werden kann.', 'red'),
    d('sie daraus entspringt, dass zu sehr auf bestehende Regeln gepocht wird', 'blue'),
    d('diese aus einem ausgeprägtem Wettbewerbsdenken resultiert.', 'orange'),
    d('Vereinbarungen im Team aufgrund hoher Konsensorientierung vertagt werden.', 'green'),
    d('hohe Qualitätsansprüche zu kleinteiligem Abwägen führen.', 'yellow'),
    d('diese durch Grundsatzdebatten um nachhaltige Entwicklungen entsteht.', 'turquoise'),
  ] },
  { label: 'Festhalten an Gewohnheiten', defs: [
    d('Traditionen unreflektiert bestehen bleiben.', 'violet'),
    d('dadurch bestehende Machtstrukturen verhärtet werden.', 'red'),
    d('dadurch dysfunktionale Regeln und Abläufe aufrechterhalten werden.', 'blue'),
    d('dadurch materialistische und leistungsorientierte Einstellungen aufrechterhalten werden.', 'orange'),
    d('in Teams langwierige, auf Konsens ausgerichtete Gruppenprozesse unhinterfragt beibehalten werden.', 'green'),
    d('dies bedeutet, immer alles komplex und ganzheitlich betrachten zu müssen.', 'yellow'),
    d('gebetsmühlenartig auf nachhaltige Auswirkungen hingewiesen wird.', 'turquoise'),
  ] },
  { label: 'Geringe Umsetzungsorientierung', defs: [
    d('Sicherheitsbedürfnisse Maßnahmen oder Projekte behindern.', 'violet'),
    d('diese durch Machtkämpfe an der Führungsspitze zustande kommt.', 'red'),
    d('statt Maßnahmen zu realisieren, lediglich Ordnungen und Strukturen geschaffen werden.', 'blue'),
    d('Personen Maßnahmen verzögern, um sich Wettbewerbsvorteile zu verschaffen.', 'orange'),
    d('aufgrund von hoher Harmonie- und Konsensorientierung im Team mehr diskutiert als verwirklicht wird.', 'green'),
    d('diese aus endlosen, komplexen Sachdiskussionen resultiert.', 'yellow'),
    d('idealistische Ansprüche pragmatische Lösungen verhindern.', 'turquoise'),
  ] },
  { label: 'Gewinner-Verlierer-Spiele', defs: [
    d('Menschen bei Machtspielen ihre eigenen Einflussmöglichkeiten negieren, um den Schutz der Gemeinschaft zu erhalten.', 'violet'),
    d('Menschen in Kauf nehmen, Vorteile auf Kosten anderer zu erzielen.', 'red'),
    d('Personen sich in ihrer Prinzipientreue gegenseitig übertrumpfen wollen.', 'blue'),
    d('es in Wettbewerbssituationen nur noch ums Gewinnen oder Verlieren geht.', 'orange'),
    d('Menschen, die sich nicht teamkonform verhalten, benachteiligt werden.', 'green'),
    d('diese über das Verstehen komplexer Zusammenhänge ausgetragen werden.', 'yellow'),
    d('diese unreflektiert aus dem Verfolgen der eigenen Ideale entstehen.', 'turquoise'),
  ] },
  { label: 'Rechthaberei', defs: [
    d('hierbei ständig auf traditionelle Glaubenssätze und Vorstellungen verwiesen wird.', 'violet'),
    d('Menschen ihre Ziele und Vorstellungen mit Macht und Sturheit durchsetzen.', 'red'),
    d('unnachgiebig auf Regeln und Prinzipien beharrt wird.', 'blue'),
    d('Menschen hartnäckig ihre materiellen Ziele verteidigen.', 'orange'),
    d('darauf bestanden wird, dass das Team immer Recht hat.', 'green'),
    d('Personen sich aufgrund ihres überlegenen Wissens immer im Recht fühlen.', 'yellow'),
    d('die Gültigkeit eines bestimmten gesellschaftlichen Ideals unnachgiebig postuliert wird.', 'turquoise'),
  ] },
  { label: 'Hierarchische Strukturen', defs: [
    d('sie dazu dienen, bestehende oder überholte Traditionen zu festigen.', 'violet'),
    d('sie zum Ausbau der eigenen Machtposition genutzt werden.', 'red'),
    d('diese durch einen großen bürokratischen Apparat zementiert werden.', 'blue'),
    d('dadurch Wettbewerbssituationen verschärft werden.', 'orange'),
    d('diese unter dem Deckmantel von Partizipation und Offenheit „verschleiert“ werden.', 'green'),
    d('sich die Komplexität einer Organisation auch in diesen Strukturen arbeitserschwerend widerspiegelt.', 'yellow'),
    d('diese zur Umsetzung von nachhaltiger Entwicklung genutzt werden.', 'turquoise'),
  ] },
  { label: 'Jedermanns Freund sein', defs: [
    d('es bedeutet, sich anderen unterzuordnen, um Sicherheit zu erlangen.', 'violet'),
    d('man sich als solcher ausgibt, nur um möglichst viel Einfluss zu haben.', 'red'),
    d('man sich in Strukturen und Ordnungen einfügt, um mit allen gut auszukommen.', 'blue'),
    d('man sich dadurch verdeckt Wettbewerbsvorteile verschaffen will.', 'orange'),
    d('man sich nur um des Gruppenkonsenses willen als solcher ausgibt.', 'green'),
    d('Personen ihr Wissen dazu nutzen, überall und von allen anerkannt zu sein.', 'yellow'),
    d('Personen betonen, dass sie ihr Handeln stets dem Gemeinwohl unterordnen.', 'turquoise'),
  ] },
  { label: 'Konfliktvermeidung', defs: [
    d('diese aus der Angst vor einem Sicherheitsverlust resultiert.', 'violet'),
    d('Auseinandersetzungen durch autoritäres Eingreifen zum eigenen Machterhalt vermieden werden.', 'red'),
    d('Regeln und Strukturen dazu benutzt werden, Kontroversen zu vermeiden.', 'blue'),
    d('diese dazu benutzt wird, eine bessere Position gegenüber anderen zu erlangen.', 'orange'),
    d('Auseinandersetzungen vermieden werden, um die Harmonie im Team nicht nachhaltig zu gefährden.', 'green'),
    d('man sich auf  Konflikte nicht einlässt und sie durch Rationalisierung umgeht.', 'yellow'),
    d('jemand konsequent das Gemeinwohl über das eigene Wohl stellt.', 'turquoise'),
  ] },
  { label: 'Konformismus', defs: [
    d('dieser bedeutet, immer im Sinne der Sicherheit der Gemeinschaft handeln zu müssen.', 'violet'),
    d('immer denjenigen gefolgt wird, die am meisten „Lärm“ machen.', 'red'),
    d('Menschen sich völlig unkritisch in Strukturen und Regeln einfügen.', 'blue'),
    d('sich dieser darin zeigt, dass sich Menschen ausschließlich am materiellen Erfolg orientieren.', 'orange'),
    d('individuelle Meinungen nicht gehört werden, sondern primär im Sinne des Teams gehandelt wird.', 'green'),
    d('dieser bedeutet, sich vorwiegend innerhalb der eigenen Community auszutauschen.', 'yellow'),
    d('sich dieser darin äußert, dass man sich nachhaltigen Werthaltungen unterordnet.', 'turquoise'),
  ] },
  { label: 'Kontrolle', defs: [
    d('diese eingesetzt wird, um die Gruppe auf dem bekannten und herkömmlichen „Kurs“ zu halten.', 'violet'),
    d('diese auf der Annahme beruht, dass Menschen motiviert werden müssen, um etwas zu leisten.', 'red'),
    d('Regeln und Strukturen dafür als Mechanismen eingesetzt werden.', 'blue'),
    d('diese dazu dient, Leistungs- und Erfolgsdruck aufzubauen.', 'orange'),
    d('diese durch emotionalen Druck auf der Beziehungsebene ausgeübt wird.', 'green'),
    d('diese über Steuerungssysteme erfolgt, die so komplex sind, dass sie nicht mehr verstanden werden.', 'yellow'),
    d('diese aus einer idealistischen Haltung heraus ausgeübt wird.', 'turquoise'),
  ] },
  { label: 'Machtausübung', defs: [
    d('sie dazu verwendet wird, bedingungslose Unterordnung unter Traditionen einzufordern.', 'violet'),
    d('jemand die Befugnisse der eigenen Position zum personlichem Vorteil ausnutzt.', 'red'),
    d('durch Kontrollstrukturen Loyalität und Prinzipientreue sichergestellt werden sollen.', 'blue'),
    d('Menschen ihren Erfolg dazu nutzen, um andere zu benachteiligen.', 'orange'),
    d('dadurch notwendige Auseinandersetzungen im Team verhindert werden.', 'green'),
    d('die eigene Kompetenz und Analysefähigkeit als Werkzeug missbräuchlich verwendet wird.', 'yellow'),
    d('Menschen dazu gebracht werden sollen, einer idealistischen Vision zu folgen.', 'turquoise'),
  ] },
  { label: 'Manipulation', defs: [
    d('diese bedeutet, sich gruppenkonform zu verhalten, um sich den Rückhalt der Gemeinschaft zu sichern.', 'violet'),
    d('diese dazu dient, den eigenen Einfluss zu erweitern.', 'red'),
    d('Personen dafür gezielt Strukturen und Regelungen einsetzen.', 'blue'),
    d('diese eingesetzt wird, um sich im Wettbewerb einen Vorteil zu verschaffen.', 'orange'),
    d('man durch eine vertrauensvolle, emotionale Atmosphäre zu einer hohen Teamorientierung gedrängt wird.', 'green'),
    d('Menschen dazu bewusst ihre Fähigkeit, komplexe Zusammenhänge zu durchschauen, einsetzen.', 'yellow'),
    d('Menschen andere im Sinne ihrer Ideale für eine gerechte Welt beeinflussen.', 'turquoise'),
  ] },
  { label: 'Oberflächlichkeit', defs: [
    d('Themen oberflächlich bearbeitet werden, um nur bekannte und akzeptierte Lösungen hervorzubringen.', 'violet'),
    d('hinter Energie und Tatendrang keine inhaltliche Tiefe steht.', 'red'),
    d('sie entsteht, weil man sich nur an Regeln hält.', 'blue'),
    d('Menschen kurzfristigen Zielen oder materiellen Erfolgen nachjagen.', 'orange'),
    d('ständiges Harmoniestreben dazu führt, dass Themen nicht tiefgründig behandelt werden.', 'green'),
    d('komplexe Diskussionen dazu führen, dass die eigentlichen Themen unberücksichtigt bleiben.', 'yellow'),
    d('der globale, ganzheitliche Blick zu einer wenig differenzierten Betrachtung wichtiger Details führt.', 'turquoise'),
  ] },
  { label: 'Statusdenken', defs: [
    d('dieses unter dem Deckmantel vermeintlich traditioneller Werte zu persönlicher Vorteilsnahme führt.', 'violet'),
    d('sich dieses in der Darstellung von Macht durch entsprechende Symbolen äußert.', 'red'),
    d('nach Ordnungen und Hierarchieebenen bewertet wird.', 'blue'),
    d('sich dieses nur über wirtschaftlichen Erfolg definiert.', 'orange'),
    d('Personen ihren Beitrag für das Team und die Identifikation mit dem Team überbetonen.', 'green'),
    d('sich Menschen über ihre Fähigkeit zum komplexen Denken profilieren.', 'yellow'),
    d('sich Menschen ausschließlich über ihr gesellschaftliches Engagement definieren.', 'turquoise'),
  ] },
  { label: 'Führungsverhalten', defs: [
    d('Führung vorwiegend auf Sicherheit und den Schutz der Gruppe ausgerichtet ist.', 'violet'),
    d('dieses zu stark durch Einflußnahme geprägt ist.', 'red'),
    d('die Führungskraft direktiv für Ordnung sorgt und striktes Pflichtbewusstsein fordert.', 'blue'),
    d('dieses fast ausschließlich auf Erfolgsorientierung ausgerichtet ist.', 'orange'),
    d('die Führungskraft zu stark die emotionalen Bedürfnisse der Mitarbeitenden fokussiert.', 'green'),
    d('zu viel Innovation und Veränderung bei hoher Flexibilität gefordert wird.', 'yellow'),
    d('die Führungskraft nachhaltige Ideale umsetzen möchte.', 'turquoise'),
  ] },
  { label: 'Rivalität', defs: [
    d('Menschen um einen sicheren Platz in der Gemeinschaft ringen.', 'violet'),
    d('um Machtpositionen gekämpft wird.', 'red'),
    d('um Prinzipientreue und Ordnung gewetteifert wird.', 'blue'),
    d('sich diese darin zeigt, dass Personen andere ausstechen wollen.', 'orange'),
    d('sich Teammitglieder in der Unterstützung des Gesamtteams gegenseitig übertrumpfen wollen.', 'green'),
    d('um intellektuelle Deutungshoheit gestritten wird.', 'yellow'),
    d('Menschen verschiedene Ideen für eine gerechte Welt gegeneinander ausspielen.', 'turquoise'),
  ] },
  { label: 'Gruppendruck', defs: [
    d('dieser auf Sicherheit und Anpassung abzielt.', 'violet'),
    d('dieser erzeugt wird, um die eigene Position zu stärken.', 'red'),
    d('dieser erzeugt wird, um ausgeprägtes Pflichtbewusstsein und Prinzipientreue zu erreichen.', 'blue'),
    d('dieser durch hohe Wettbewerbsorientierung aufgebaut wird.', 'orange'),
    d('dieser hoch ist und dazu dient, Konsens im Team herzustellen.', 'green'),
    d('dieser in Netzwerken aufgebaut wird, um einheitlich hohe Qualitätsansprüche zu gewährleisten.', 'yellow'),
    d('er aus der Orientierung an einer gesellschaftlichen Zukunftsvision entsteht.', 'turquoise'),
  ] },
  { label: 'Sturheit', defs: [
    d('dauerhaft an traditionellen Wegen festgehalten wird.', 'violet'),
    d('Personen durchsetzungsstark ohne Kompromissbereitschaft auftreten.', 'red'),
    d('unflexibel an bestehenden Regeln und Vorschriften festgehalten wird.', 'blue'),
    d('Personen aus Wettbewerbsgründen verbissen an unrealistischen Zielen festhalten.', 'orange'),
    d('kompromisslos darauf beharrt wird, dass in Diskussionen auch noch die letzte Person überzeugt werden muss.', 'green'),
    d('man hartnäckig auf komplexe Analysen und höchste Qualitätsansprüche beharrt.', 'yellow'),
    d('an einem globalen, idealistischen Weltbild festgehalten wird, obwohl es einfache, individuelle Lösungen bräuchte.', 'turquoise'),
  ] },
  { label: 'Theoretisieren', defs: [
    d('Menschen sich damit einer gemeinsamen Basis versichern wollen, die ihnen Halt gibt.', 'violet'),
    d('dies der Demonstration von Macht und Überlegenheit dient.', 'red'),
    d('nur um der Struktur und Ordnung willen theoretisiert wird.', 'blue'),
    d('zu lange um Erfolgskennzahlen gerungen wird.', 'orange'),
    d('man vor lauter Gemeinschaftssinn und Konsensorientierung nicht über die theoretische Betrachtung hinaus kommt.', 'green'),
    d('dieses in komplexen Sachdiskussionen zum Selbstzweck wird.', 'yellow'),
    d('über globale Visionen nur abstrakte Überlegungen angestellt werden, ohne sie konkret umzusetzen.', 'turquoise'),
  ] },
  { label: 'Überempfindlichkeit', defs: [
    d('Menschen schnell ihre eigene Sicherheit und ihren Platz in der Gemeinschaft gefährdet sehen.', 'violet'),
    d('sich jemand schnell in seinem Gestaltungsdrang angegriffen fühlt.', 'red'),
    d('sich jemand übertrieben schnell in seinem Ordnungssinn gestört fühlt.', 'blue'),
    d('sich diese darin zeigt, dass Menschen nicht verlieren können.', 'orange'),
    d('man sofort die Teamatmosphäre gefährdet sieht.', 'green'),
    d('man direkt auf das Infragestellen der eigenen Kompetenz und Analysefähigkeit reagiert.', 'yellow'),
    d('man sich durch pragmatische Ansätze in der eigenen globalen Sichtweise provoziert fühlt.', 'turquoise'),
  ] },
  { label: 'Unberechenbarkeit', defs: [
    d('Menschen aufgrund ihres hohen Sicherheitsbedürfnisses unberechenbar reagieren.', 'violet'),
    d('diese durch impulsives Handeln entsteht.', 'red'),
    d('ein Dschungel von Vorschriften und Regeln keine vorhersehbaren Lösungen oder Vorgehensweisen erkennen lässt.', 'blue'),
    d('sich Personen damit verdeckte Wettbewerbsvorteile verschaffen wollen.', 'orange'),
    d('diese durch unvorhersehbare dynamische Gruppenprozesse erzeugt wird.', 'green'),
    d('stets so viele Möglichkeiten offen gehalten werden, dass Prozesse oder Personen unkalkulierbar werden.', 'yellow'),
    d('die Folgen miteinander verflochtener globaler Prozesse nicht abschätzbar sind.', 'turquoise'),
  ] },
  { label: 'Unentschlossenheit', defs: [
    d('diese aus einem hohen Sicherheitsbedürfnis und einer Orientierung an Traditionen resultiert.', 'violet'),
    d('Personen abwarten, welche Strategie ihnen den größten Einfluss sichert.', 'red'),
    d('nicht aktiv gehandelt wird, weil formale Anforderungen nicht geklärt werden können.', 'blue'),
    d('man zögert, weil man Angst hat, im Wettbewerb zu verlieren.', 'orange'),
    d('aufgrund hoher Konsensorientierung langwierige Einigungsprozesse resultieren.', 'green'),
    d('auf der Suche nach höchster Qualität das Abwägen verschiedener Möglichkeiten zu keiner Entscheidung führt.', 'yellow'),
    d('ein ganzheitlicher, globaler Blick die Entschlussfreude für kurzfristige, pragmatische Lösungen hemmt.', 'turquoise'),
  ] },
  { label: 'Vorschnelle Entscheidungen', defs: [
    d('sie dazu führen, dass Bewährtes erhalten bleibt und Innovationen vermieden werden.', 'violet'),
    d('Menschen ihre Durchsetzungsfähigkeit nutzen, um übereilt Entscheidungen zu treffen.', 'red'),
    d('diese durch den bloßen Rückgriff auf Regeln und Prinzipien getroffen werden.', 'blue'),
    d('diese rein auf Gewinnmaximierung ausgerichtet sind.', 'orange'),
    d('nur aufgrund der Bedürfnisse des Teams getroffen werden.', 'green'),
    d('Menschen aufgrund ihrer Kompetenzüberlegenheit anderen schnelle Entscheidungen aufdrängen.', 'yellow'),
    d('man voreilig globale Strategien verfolgt, anstatt zunächst operative Probleme zu lösen.', 'turquoise'),
  ] },
  { label: 'Unklarheit', defs: [
    d('neue Informationen ungenau gehalten werden, um Bestehendes zu erhalten.', 'violet'),
    d('bewusst eingesetzt wird, um die eigene Machtposition zu stärken.', 'red'),
    d('diese durch ein Zuviel an Regeln entsteht.', 'blue'),
    d('man diese bewusst nutzt, um sich Vorteile zu verschaffen.', 'orange'),
    d('diese entsteht, weil Diskussionen stets in aller Breite verlaufen und Störungen zugelassen werden.', 'green'),
    d('zu komplexe Abwägungen zu unverständlichen Konzepten führen.', 'yellow'),
    d('die Art und Weise der Umsetzung globaler Ideale intransparent bleibt.', 'turquoise'),
  ] },
  { label: 'Unkritisch sein', defs: [
    d('traditionelle und sicherheitsorientierte Werte nicht in Frage gestellt werden.', 'violet'),
    d('Menschen ihr eigenes Machtstreben nicht reflektieren.', 'red'),
    d('etablierte Regeln und Strukturen unhinterfragt akzeptiert werden.', 'blue'),
    d('diese daraus resultiert, weil sich Menschen davon einen Wettbewerbsvorteil versprechen.', 'orange'),
    d('man dem Teamkonsens folgt, ohne diesen zu hinterfragen.', 'green'),
    d('es bedeutet, Vorschläge von Personen, die als kompetent angesehen werden, nicht in Frage zu stellen.', 'yellow'),
    d('eigene Bedürfnisse zugunsten nachhaltiger Ziele unreflektiert zurückgestellt werden.', 'turquoise'),
  ] },
  { label: 'Untergeordnet sein', defs: [
    d('man sich den Bedürfnissen in der Gruppe nach Sicherheit und Beständigkeit fügen muss.', 'violet'),
    d('dies dazu führt, dass Personen unkontrolliert machtbewusst agieren können.', 'red'),
    d('Regeln und Strukturen das eigene Handeln fremdbestimmen.', 'blue'),
    d('man sich stets am Wettbewerb und an Zielvorgaben ausrichten muss.', 'orange'),
    d('man individuelle Interessen stets gegenüber den Teaminteressen zurückstellen muss.', 'green'),
    d('man sich an den hohen Innovationsansprüchen des Umfelds ausrichten muss.', 'yellow'),
    d('man die eigenen Bedürfnisse dem Gemeinwohl unterstellen muss.', 'turquoise'),
  ] },
  { label: 'Weltfremdheit', defs: [
    d('eine Gruppe versucht, naive Bedürfnisse nach Sicherheit und Zusammenhalt zu leben.', 'violet'),
    d('Personen nur um sich selbst, ihre eigenen Interessen und ihren Machterhalt kreisen.', 'red'),
    d('Sinn und Zweck von Strukturen und Formalien nicht mehr klar erkennbar sind.', 'blue'),
    d('Menschen nur den materiellen Erfolg fokussieren und alles andere ausblenden.', 'orange'),
    d('in Gruppen ständig die Gruppenbedürfnisse im Vordergrund stehen.', 'green'),
    d('komplexe Analysen systemischer Zusammenhänge zu unrealistischen Konzepten führen.', 'yellow'),
    d('aus nachhaltigen und ganzheitlichen Sichtweisen unrealistische Maßnahmen abgeleitet werden.', 'turquoise'),
  ] },
]

// Survey-Spec für die Engine
export const MIWAY_4 = {
  slug: 'miway-4',
  name: 'MiWay - Werte- und Motivationsanalyse 4.0',
  totalSteps: 26,
  welcome: {
    headline: 'Herzlich Willkommen',
    subheadline: 'zur Motivations- und Werteanalyse MiWay',
    body: [
      'Im Folgenden werden Sie Ihre wichtigsten Arbeits- und Karrierewerte reflektieren. Dabei werden sowohl die Werte bestimmt, die Sie motivieren als auch die Werte, die Sie eher demotivieren.',
      'Sie können hierbei keine richtige oder falsche Auswahl treffen. Um ein aussagekräftiges Ergebnis zu erhalten, das Ihre persönlichen Präferenzen widerspiegelt, ist es wichtig, dass Sie möglichst spontan antworten.',
      'Damit Ihr individuelles berufsbezogenes Werteprofil erstellt werden kann, durchlaufen Sie zwei Phasen:',
    ],
    list: [
      'Sie wählen Ihre wichtigsten Motivatoren im Arbeitskontext aus. Für diese wählen Sie die für Sie jeweils zutreffendsten Definitionen aus.',
      'Sie wählen Ihre wichtigsten Demotivatoren im Arbeitskontext aus. Für diese wählen Sie die für Sie jeweils zutreffendsten Definitionen aus.',
    ],
  },
  motivators: MOTIVATORS,
  demotivators: DEMOTIVATORS,
  copy: {
    motivatorTitle: 'Was motiviert Sie?',
    motivatorIntro: 'Wir beginnen zunächst mit den für Sie wichtigsten Motivatoren im Arbeitskontext. Wählen Sie hierzu aus den aufgeführten Begriffen, die für Sie wichtigsten 10 Motivatoren aus.',
    motivatorCounter: '{n} von 10 Motivatoren ausgewählt',
    motivatorDefIntro: 'Wählen Sie nun für jeden Motivator, den Sie ausgewählt haben, die beiden Definitionen aus, die am ehesten auf Sie zutreffen. Die erste Auswahl, die Sie treffen, beschreibt die Definition, die am besten auf Sie zutrifft, während die zweite diejenige ist, die am nächstbesten auf Sie zutrifft. Wählen Sie diese durch einen einfachen Klick aus oder ziehen Sie diese dafür jeweils in das obere Feld.',
    motivatorDefValidation: 'Bitte wählen Sie für diesen Motivator die zwei Definitionen aus, die am ehesten auf Sie zutreffen.',
    motivatorAdditional: 'Geben Sie hier bitte maximal fünf zusätzliche Motivatoren an, die Sie in Ihrem Berufsleben motivieren und die Sie an dieser Stelle ergänzen möchten.',
    transition: 'Sie haben die Motivatoren ausgewählt und bearbeitet, die für Sie wichtig sind. Im nächsten Schritt liegt der Fokus auf Ihren Demotivatoren.',
    demotivatorTitle: 'Was demotiviert Sie?',
    demotivatorIntro: 'Wir fahren mit den für Sie wichtigsten Demotivatoren im Arbeitskontext fort. Wählen Sie hierzu aus den aufgeführten Begriffen, die für Sie wichtigsten 10 Demotivatoren aus.',
    demotivatorCounter: '{n} von 10 Demotivatoren ausgewählt',
    demotivatorDefIntro: 'Wählen Sie nun für jeden Demotivator, den Sie ausgewählt haben, die beiden Definitionen aus, die am ehesten auf Sie zutreffen. Die erste Auswahl, die Sie treffen, beschreibt die Definition, die am besten auf Sie zutrifft, während die zweite diejenige ist, die am nächstbesten auf Sie zutrifft. Wählen Sie diese durch einen einfachen Klick aus oder ziehen Sie diese dafür jeweils in das obere Feld.',
    demotivatorDefValidation: 'Bitte wählen Sie für diesen Demotivator die zwei Definitionen aus, die am ehesten auf Sie zutreffen.',
    demotivatorAdditional: 'Geben Sie hier bitte maximal fünf zusätzliche Demotivatoren an, die Sie in Ihrem Berufsleben demotivieren und die Sie an dieser Stelle ergänzen möchten.',
    dropZone: 'Satz vervollständigen und priorisieren',
    motivatorMotiviert: 'motiviert mich, wenn',
    demotivatorMotiviert: 'demotiviert mich, wenn',
    organisationRequired: 'Bitte geben Sie den Namen der Organisation an, in der Sie aktuell arbeiten.',
  },
}
